import React, { createContext, useCallback, useMemo, useState } from "react";
import { UserProfileInfo } from "../types";

interface UserProfileInfoContextData {
  userProfileInfo: UserProfileInfo[];
  setUserProfileInfoContextData: (userProfileInfo: UserProfileInfo[]) => void;
  setUserProfileFieldValues: (id: string, updatedFields: Partial<UserProfileInfo>) => void;
}

export const UserProfileInfoContext = createContext<UserProfileInfoContextData>({
  userProfileInfo: [],
  setUserProfileInfoContextData: () => { },
  setUserProfileFieldValues: () => { },
});

export const UserProfileInfoProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {

  const [userProfileInfo, setUserProfileInfoContextData] = useState<UserProfileInfo[]>([]);

  const setUserProfileFieldValues = useCallback((id: string, updatedFields: Partial<UserProfileInfo>) => {
    setUserProfileInfoContextData((prevUserProfileInfo) =>
      prevUserProfileInfo.map((profile) =>
        profile.Id === id ? { ...profile, ...updatedFields } : profile
      )
    );
  }, []);

  const value = useMemo(() => ({ userProfileInfo, setUserProfileInfoContextData, setUserProfileFieldValues }), [userProfileInfo, setUserProfileFieldValues]);

  return (
    <UserProfileInfoContext.Provider value={value}>
      {children}
    </UserProfileInfoContext.Provider>
  );
};
